import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id", "xstyle", "className", "style"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import * as stylex from '@stylexjs/stylex';
import { mergeStylexProps } from 'stylex-utils';
import { InternalIconWrapper } from 'trellis-assets/icons/InternalIconWrapper';
import { normalizeSizeProp } from 'trellis-assets/icons/normalizeSizeProp';
import { jsx as _jsx } from "react/jsx-runtime";
export const LinkExternalIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id,
      xstyle
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  // Setting default values here
  const color = (colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit') === 'inherit' ? 'currentColor' : colorProp; // inherit = currentColor = text color of the closest element
  const styleProps = mergeStylexProps(stylex.props(normalizeSizeProp(sizeProp, 'LinkExternalIcon')), {
    color
  });
  return /*#__PURE__*/_jsx(InternalIconWrapper, {
    xstyle: xstyle,
    alignWithText: alignWithText,
    children: /*#__PURE__*/_jsx("svg", Object.assign({}, restProps, styleProps, {
      "aria-label": ariaLabel,
      "aria-hidden": ariaLabel === undefined ? true : undefined,
      id: id,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      focusable: "false",
      "data-icon-name": "LinkExternal",
      children: /*#__PURE__*/_jsx("path", {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M14.273 17.727 27 5M19 5h8v8M15 9H7v16h16v-8"
      })
    }))
  });
};
LinkExternalIcon.displayName = 'LinkExternalIcon';